import React, { Component } from 'react';
import { Row, Col, Button, Icon, Card } from 'antd';

class FormatWrapper extends Component {
    constructor(props) { super(props); }
    render() {
        const { style, hasHeader } = this.props;
        let
        span = 0,
        top = style.top || null,
        bottom = style.bottom || null,
        colStyle = {
            position: 'relative',
            left: '14px',
            bottom: bottom || '48px'
        },
        divTable = {
            display: 'table',
            width: '100%',
            height: '100%'
        },
        divTableCell = {
            display: 'table-cell',
            verticalAlign: 'middle'
        };

        switch(this.props.type) {
            case 'buttonLeft':
                span = 2;
                colStyle = {...colStyle, left: '0px' };
                divTableCell = {...divTableCell, textAlign: 'right' };
                break;
            case 'buttonRight':
                span = 2;
                colStyle = {...colStyle, right: '0px' };
                divTableCell = {...divTableCell, textAlign: 'left' };
                break;
            case 'content':
                colStyle = {...colStyle, overflow: 'visible' };
                span = 20;
                break;
        }

        return (
            <Col span={span} style={colStyle}>
                <div style={divTable}>
                    <div style={divTableCell}>
                        {this.props.children}
                    </div>
                </div>
            </Col>
        );
    }
}

export default class SsStep extends Component {
    view = null
    state = {
        allowStepChange: true,
        callbacks: {
            back: null,
            next: null
        },
        requiredCallback: {
            back: null,
            next: null
        },
        ui: {
            disableBack: false,
            disableNext: false,
            back: null,
            next: null,
            view: null
        }
    }

    constructor(props) {
        super(props);
    }

    getState(p) {
        let { state, id, fullState } = p;
        if(state != null) {
            if(!fullState) {
                for(let p in state) if(p === id) return state[p];
                return 'No state found.';
            } else return state;
        } else return null;
    }

    addCallback(type, callback) {
        this.setState({...this.state,
            callbacks: {...this.state.callbacks,
                [type]: callback
            }
        });
    }

    addRequiredCallback(type, callback) {
        this.setState({...this.state,
            requiredCallback: {...this.state.requiredCallback,
                [type]: callback
            }
        });
    }

    requiredCallbackCheck(type, e) {
        const
        { controls } = this.props,
        { requiredCallback } = this.state;
        let rcb = null;
        switch(type) {
            case 'back':
                if(requiredCallback.back != null) rcb = requiredCallback.back;
                break;
            case 'next':
                if(requiredCallback.next != null) rcb = requiredCallback.next;
                break;
        }
        if(rcb) {
            if(rcb(e))
                if(this.state.allowStepChange) {
                    controls.toggleStepChange('enable');
                    return true;
                }
            controls.toggleStepChange('disable');
            return false;
        } else return true;
    }

    handleStep(type, e) {
        const { callbacks } = this.state;
        let c = null, cb = null;

        switch(type) {
            case 'back':
                c = this.props.controls.back;
                if(callbacks.back != null) cb = callbacks.back;
                break;
            case 'next':
                c = this.props.controls.next;
                if(callbacks.next != null) cb = callbacks.next;
                break;
        }

        if(this.requiredCallbackCheck(type, e)) {
            if(cb) cb(e);
            if(c) c();
        }
    }

    getDisabledButton(type) {
        switch(type) {
            case 'back': return (
                <Button disabled>
                    <Icon type='left' />{' Back'}
                </Button>
            );
            case 'next': return (
                <Button disabled>
                    {'Next '}<Icon type='right' />
                </Button>
            );
        }
    }

    buildBackControls(p) {
        const { currentStep, lastStep } = p;
        let back = null;
        if(!this.state.ui.disableBack && currentStep !== 0)
            back = (
                <Button onClick={(e) => this.handleStep('back', e)}>
                    <Icon type='left' />{' Back'}
                </Button>
            );
        else if(this.state.ui.disableBack && currentStep !== 0)
            back = this.getDisabledButton('back');
        return back;
    }

    buildNextControls(p) {
        const { currentStep, lastStep } = p;
        let next = null;
        if(!this.state.ui.disableNext && currentStep !== lastStep)
            next = (
                <Button onClick={(e) => this.handleStep('next', e)}>
                    {'Next '}<Icon type='right' />
                </Button>
            );
        else if(this.state.ui.disableNext && currentStep !== lastStep)
            next = this.getDisabledButton('next');
        return next;
    }

    toggleDisabledButton(type) {
        const
        { ui } = this.state,
        { disableBack, disableNext } = ui;
        let newUi = null;
        switch(type) {
            case 'back':
                newUi = {...ui,
                    disableBack: !disableBack,
                    back: this.getDisabledButton('back')
                };
                break;
            case 'next':
                newUi = {...ui,
                    disableNext: !disableNext,
                    next: this.getDisabledButton('next')
                };
                break;
            default:
                newUi = {...ui,
                    disableBack: !disableBack,
                    disableNext: !disableNext,
                    back: this.getDisabledButton('back'),
                    next: this.getDisabledButton('next')
                };
        }
        this.setState({...this.state, ui: newUi });
    }

    injectSsStepControls(obj, type) {
        const
        // Bank of functions
        controls = {
            next: (func) => this.addCallback('next', func),
            back: (func) => this.addCallback('back', func),
            requireBeforeNext: (func) => this.addRequiredCallback('next', func), // MUST return true to continue execution.
            requireBeforeBack: (func) => this.addRequiredCallback('back', func), // MUST return true to continue execution.
            toggleNext: () => this.toggleDisabledButton('next'),
            toggleBack: () => this.toggleDisabledButton('back'),
            toggleBoth: () => this.toggleDisabledButton()
        },
        inject = (s) => {
            if(s.length === 1 && s[0] === '*') {
                for(let c in controls)
                    if(!obj.hasOwnProperty(c))
                        obj[c] = controls[c];
            } else {
                for(let c in controls)
                    if(!obj.hasOwnProperty(c) && s.indexOf(c) !== -1)
                        obj[c] = controls[c];
            }
            return {...obj};
        };
        switch(type) {
            case 'back': return inject([
                'back',
                'requireBeforeBack',
                'toggleBack'
            ]);
            case 'next': return inject([
                'next',
                'requireBeforeNext',
                'toggleNext'
            ]);
            default: return inject([ '*' ]);
        }
    }

    buildView(p) {
        let
        view = null,
        props = {
            state: this.getState(p),
            services: p.services,
            data: {
                currentStep: p.currentStep,
                id: p.id,
                title: p.title,
                icon: p.icon,
                description: p.description,
                status: p.status,
                targetStep: p.targetStep
            },
            controls: {
                layout: {
                    updateIcon: p.controls.updateIcon,
                    updateStatus: p.controls.updateStatus,
                    updateTitle: p.controls.updateTitle,
                    getSteps: p.controls.getSteps,
                    clearTargetStep: p.controls.clearTargetStep,
                    targetStep: p.controls.targetStep,
                    changeStep: p.controls.changeStep
                },
                step: {}
            },
        };

        if(p.currentStep === 0)
            props.controls.step = this.injectSsStepControls(props.controls.step, 'next');
        else if(p.currentStep === p.lastStep)
            props.controls.step = this.injectSsStepControls(props.controls.step, 'back');
        else
            props.controls.step = this.injectSsStepControls(props.controls.step);

        if(p.noState) delete props.state;
        return React.cloneElement(p.render(), props);
    }

    buildUI(p) {
        this.setState({...this.state,
            ui: {...this.state.ui,
                back: this.buildBackControls(p),
                next: this.buildNextControls(p),
                view: this.buildView(p)
            }
        });
    }

    componentWillMount() {
        this.buildUI(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.buildUI(nextProps);
    }

    render() {
        const
        { hasHeader, stepStyle } = this.props,
        { ui } = this.state;

        let
        formatWrapperProps = {
            hasHeader: hasHeader,
            style: stepStyle
        },
        colStyle = {
            position: 'fixed',
            top: '240px',
            bottom: '48px'
        },
        spanStyle = {
            display: 'table-cell',
            verticalAlign: 'middle'
        };

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={23}>
                        <Row type='flex' justify='space-around' align='middle'>
                            <FormatWrapper {...{...formatWrapperProps, type: 'buttonLeft'}}>
                                {ui.back}
                            </FormatWrapper>
                            <FormatWrapper {...{...formatWrapperProps, type: 'content'}}>
                                {ui.view}
                            </FormatWrapper>
                            <FormatWrapper {...{...formatWrapperProps, type: 'buttonRight'}}>
                                {ui.next}
                            </FormatWrapper>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
